import React, { Component, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Loading } from '../Loading';


export const HybirdContext = React.createContext(undefined);

export default class HybirdContextContainer extends Component {
  static propTypes = {
    bridge: PropTypes.object
  };
  render() {
    const {bridge, children} = this.props;
    return (
      <HybirdContext.Provider value={bridge}>
        {bridge && children}
      </HybirdContext.Provider>
    )
  }
}

export const withHybird = (Component) => {
  return (props) => (
    <HybirdContext.Consumer>
      {(context) => {
        return <Component {...props} context={context} />
      }}
    </HybirdContext.Consumer>
  )
};

export const withDeepLink = (Component) => {
  return (props) => {
    const hybirdContext = useContext(HybirdContext);
    const [showLocking, setLocking] = useState(false);
    const onDeepLinkClick = (url) => {
      if (/^((http|https|ftp):\/\/)/.test(url)) {
        setLocking(true);
        document.body.classList.add('modal-open');
        document.documentElement.className='modal-open';
        setTimeout(() => {
          hybirdContext.goToNativeDeepLink(url);
        }, 300);
      } else {
        console.log(`go deep to: ${url}`)
        url && hybirdContext.goToNativeDeepLink(url);
      }
    };
    const onTrackState = (name, context, cb) => {
      name && hybirdContext.trackState(name, context, cb)
    };
    const onTrackAction = (name, context, cb) => {
      name && hybirdContext.trackAction(name, context, cb)
    };
    return <>
      <Component {...props} onDeepLink={onDeepLinkClick} onTrackState={onTrackState} onTrackAction={onTrackAction}/>
      {showLocking && <div className="app-loading locking">
        <div className="loader-overlay">
          <Loading/>
        </div>
      </div>}
      </>
  };
};
